import React from "react";
import PenIcon from "@/assets/pen.png";
import { ContributionData } from "@/types/summary";

interface ContributionSectionProps {
  data?: ContributionData;
  onEdit: () => void;
}

const ContributionSection: React.FC<ContributionSectionProps> = ({
  data,
  onEdit,
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  if (!data) {
    return (
      <div className="border border-[#E6E6E6] rounded-[12px] p-[20px]">
        <div className="flex justify-between items-center mb-[16px]">
          <h3 className="text-[18px] font-semibold text-gray-900">
            Contribution
          </h3>
          <button
            onClick={onEdit}
            className="text-[#00ADAC] hover:text-[#008281] font-medium text-[14px] cursor-pointer border-none bg-transparent flex items-center gap-1"
          >
            <svg className="w-4 h-4" viewBox="0 0 16 16" fill="currentColor">
              <path d="M11.13 3.95L12.05 4.87L4.87 12.05L3.95 11.13L11.13 3.95Z" />
              <path d="M12.05 3.95L13.95 2.05L14.95 3.05L13.05 4.95L12.05 3.95Z" />
            </svg>
            Edit
          </button>
        </div>
        <div className="text-center py-[20px] text-gray-500">
          <p>No contribution information available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="border-b-[1px] border-[#E2E2E2] p-[20px]">
      <div className="flex justify-between items-center mb-[16px]">
        <h3 className="text-[1.125rem]">Contribution</h3>
        <button
          onClick={onEdit}
          className="text-[#00ADAC] hover:text-[#008281] text-[1.125rem] cursor-pointer border-none bg-transparent flex items-center gap-1"
        >
          <img src={PenIcon} className="w-[18px] h-[18px]" alt="Edit" />
          Edit
        </button>
      </div>

      <div className="space-y-[12px]">
        <div>
          <p className="text-[16px]">
            My contribution: {data.employeeTotalContribution}% (
            {formatCurrency(data.employeeTotalContributionInDollar)})
          </p>
        </div>

        {(data.employerTotalContribution > 0 ||
          data.employerTotalContributionInDollar > 0) && (
          <div>
            <p className="text-[16px]">
              Employer contribution: {data.employerTotalContribution}% (
              {formatCurrency(data.employerTotalContributionInDollar)})
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContributionSection;
